import React from 'react';

const FUNNEL_COLORS = [
  'bg-indigo-200',
  'bg-indigo-300',
  'bg-indigo-400',
  'bg-indigo-500',
  'bg-indigo-600',
  'bg-indigo-700',
];

const FUNNEL_TEXT_COLORS = [
  'text-indigo-900',
  'text-indigo-900',
  'text-white',
  'text-white',
  'text-white',
  'text-white',
];

const FunnelCard = ({ card }) => {
  if (!card || !card.steps || card.steps.length === 0) return null;

  const maxValue = card.steps[0].value || 1;

  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-4 shadow-sm w-full mt-3">
      {card.title && (
        <div className="text-xs font-semibold text-gray-700 mb-3">{card.title}</div>
      )}
      <div className="space-y-1">
        {card.steps.map((step, i) => {
          const widthPct = Math.max((step.value / maxValue) * 100, 20);
          const bgColor = FUNNEL_COLORS[Math.min(i, FUNNEL_COLORS.length - 1)];
          const textColor = FUNNEL_TEXT_COLORS[Math.min(i, FUNNEL_TEXT_COLORS.length - 1)];
          const prevStep = i > 0 ? card.steps[i - 1] : null;
          const dropOff = prevStep
            ? (((prevStep.value - step.value) / prevStep.value) * 100).toFixed(1)
            : null;
          const convRate = prevStep
            ? ((step.value / prevStep.value) * 100).toFixed(1)
            : null;

          return (
            <div key={i}>
              {dropOff != null && (
                <div className="flex items-center gap-2 my-1 ml-2">
                  <div className="text-[10px] text-gray-400">
                    <span className="text-red-500">{dropOff}% drop</span>
                    {' \u00B7 '}
                    <span className="text-green-600">{convRate}% conv</span>
                  </div>
                </div>
              )}
              <div
                className={`${bgColor} rounded-lg px-3 py-2 flex items-center justify-between mx-auto`}
                style={{ width: `${widthPct}%` }}
              >
                <span className={`text-[11px] font-medium ${textColor}`}>
                  {step.label}
                </span>
                <span className={`text-[11px] font-bold ${textColor}`}>
                  {Number(step.value).toLocaleString()}
                </span>
              </div>
            </div>
          );
        })}
      </div>
      {card.steps.length >= 2 && (
        <div className="mt-3 text-[10px] text-gray-500 text-center">
          Overall conversion: {((card.steps[card.steps.length - 1].value / maxValue) * 100).toFixed(1)}%
        </div>
      )}
      {card.period && (
        <div className="mt-2 text-[10px] text-gray-400 text-right font-mono">
          {card.period.start} &rarr; {card.period.end}
        </div>
      )}
    </div>
  );
};

export default FunnelCard;
